<template>
  <div class="mt-5 md:mt-0 md:col-span-2">
    <Mutation
      :mutation="currentUserMutation"
      :variables="variables"
      :refetchQueries="refetchQueries"
      @done="onDone"
      @error="onError"
    >
      <template v-slot="{ mutate, loading }">
        <ValidationObserver
          ref="observer"
          tag="form"
          @submit.prevent="submit(mutate)"
        >
          <div class="shadow sm:rounded-md sm:overflow-hidden">
            <div class="px-4 py-5 bg-white sm:p-6 grid grid-cols-3 gap-6">
              <div class="col-span-4 sm:col-span-3">
                <TextInput v-model="proposedEmail" name="email" label="Email address" rules="email|required" />
              </div>
              <div class="col-span-3 sm:col-span-3">
                <TextInput v-model="proposedFirst" label="First name" name="first" />
              </div>
              <div class="col-span-3 sm:col-span-3">
                <TextInput v-model="proposedLast" label="Last name" name="last" />
              </div>
              <div class="col-span-3 sm:col-span-3">
                <div class="relative flex items-start">
                  <div class="flex items-center h-5">
                    <input v-model="proposedWantsEmailNotifications" id="proposedWantsEmailNotifications" type="checkbox" class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out">
                  </div>
                  <div class="ml-3 text-sm leading-5">
                    <label for="proposedWantsEmailNotifications" class="font-medium text-gray-700">Receive email notifications</label>
                    <p class="text-gray-500">Get email notifications when I'm messaged on Cardstock (no more frequently than once an hour).</p>
                  </div>
                </div>
              </div>

            </div>
            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
              <span class="inline-flex rounded-md shadow-sm">
                <button
                  type="submit"
                  tabindex="1"
                  class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-cardstock-green-600 hover:bg-cardstock-green-500 focus:outline-none focus:border-cardstock-green-700 focus:ring-cardstock-green active:bg-cardstock-green-700 transition duration-150 ease-in-out"
                  :disabled="loading"
                >
                  Save
                </button>
              </span>
            </div>
          </div>
        </ValidationObserver>
      </template>
    </Mutation>
  </div>
</template>


<script>
import ButtonSubmit from '@/components/ButtonSubmit.vue'
import Mutation from '@/components/Mutation.vue'
import TextInput from '@/components/TextInput.vue'

import CurrentUserMutation  from '@/mutations/CurrentUserUpdate.gql'
import CurrentUserQuery     from '@/queries/CurrentUser.gql'

import {
  ValidationObserver,
  ValidationProvider
} from "vee-validate";


export default {
  components: {
    ButtonSubmit,
    Mutation,
    TextInput,
    ValidationObserver,
    ValidationProvider
  },

  props: {
    currentUser: {
      required: true
    }
  },

  data() {
    return {
      currentUserMutation: CurrentUserMutation,
      proposedFirst: '',
      proposedLast: '',
      proposedEmail: '',
      proposedWantsEmailNotifications: false,
      refetchQueries: () => { return ['currentUser'] }
    }
  },

  computed: {
    variables() {
      return {
        first: this.proposedFirst,
        last: this.proposedLast,
        email: this.proposedEmail,
        wantsEmailNotifications: this.proposedWantsEmailNotifications
      }
    }
  },

  methods: {
    onDone() {
      Bus.$emit('flash-message', {text: 'User info saved', type: 'success'})
    },

    onError(e) {
      Bus.$emit('flash-message', {text: 'Unable to save user info', type: 'error'})
    },

    async submit(mutate) {
      const isValid = await this.$refs.observer.validate()
      if (isValid) { mutate() }
    }
  },

  mounted() {
    this.proposedFirst = this.currentUser.first
    this.proposedLast = this.currentUser.last
    this.proposedEmail = this.currentUser.email
    this.proposedWantsEmailNotifications = this.currentUser.wantsEmailNotifications
  },

  watch: {
    currentUser: function (newCurrentUser, oldCurrentUser) {
      console.log('watcher')
      this.proposedFirst = newCurrentUser.first
      this.proposedLast = newCurrentUser.last
      this.proposedEmail = newCurrentUser.email
    }
  }
}
</script>
